export default {
    token: '',
};
